import { NavLink } from "react-router-dom";
import { LOGIN_ROUTE, REGISTRATION_ROUTE } from "../utils/const";
import { Card, CardContent, CardFooter, CardHeader, CardTitle } from "./ui/card";
import { Input } from "./ui/input";
import { Button } from "./ui/button";
import { InputMask } from "@react-input/mask";
import logo from "../assets/img/logo.png";
import s from "../styles/modules/Auth.module.scss";
import { AuthFormProps } from "../@types/props.types";
import { Typography } from "./ui/typography";

const AuthForm = ({
  isLogin,
  phone,
  setPhoneValue,
  code,
  setCodeValue,
  inputCode,
  password,
  setPasswordValue,
  passwordCheck,
  setPasswordValueCheck,
  inputPassword,
  isTimerActive,
  timer,
  passwordsMatch,
  handleResendCode,
  click,
  loginToggle,
}: AuthFormProps) => {
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    click();
  };

  return (
    <Card className="card-responsive relative p-8 pb-6 pt-6">
      <div className={s.logo_container}>
        <img src={logo} alt="АкваСтар" className="h-16 w-auto" />
        <div className="flex flex-col">
          <div className={s.logo_text}>АкваСтар</div>
          <div className="text-sm text-gray-500">Личный кабинет</div>
        </div>
      </div>
      <CardHeader className="px-0 pt-0">
        <CardTitle className="card-title mb-0" style={{ color: "#4ab0dd" }}>
          {isLogin ? "Вход в систему" : "Установить пароль"}
        </CardTitle>
      </CardHeader>
      <form onSubmit={handleSubmit}>
        <CardContent className="space-y-4 px-0">
          <InputMask
            mask="+7 (___) ___-__-__"
            replacement={{ _: /\d/ }}
            placeholder="+7 (___) ___-__-__"
            onChange={setPhoneValue}
            track={({ inputType, data }) => {
              if (inputType !== "insert" || !data) return data;
              // Strip +7/8/7 prefix from autocomplete/paste
              const digits = data.replace(/\D/g, "");
              if (digits.length >= 10 && /^[78]/.test(digits)) {
                return digits.slice(1);
              }
              return data;
            }}
            component={Input}
            type="tel"
            name="phone"
            autoComplete="tel"
            className="input-responsive"
          />
          {inputCode && (
            <div>
              <Input
                name="code"
                type="text"
                placeholder="Введите код из СМС"
                className="input-responsive"
                onChange={(e) => setCodeValue(e.target.value)}
              />
              <div className="flex flex-col items-center gap-2 pt-6">
                <span className="text-sm text-gray-500">Не пришёл код?</span>
                <div className="flex items-center gap-2">
                  <Button
                    type="button"
                    variant="link"
                    className="h-auto p-0 text-sm font-medium text-primary hover:text-primary/80"
                    onClick={handleResendCode}
                    disabled={isTimerActive}
                  >
                    Отправить код еще раз
                  </Button>
                  {isTimerActive && <span className="text-sm text-gray-400">({timer} сек)</span>}
                </div>
              </div>
            </div>
          )}
          {inputPassword && (
            <>
              <Input
                name="password"
                type="password"
                placeholder="Придумайте пароль"
                className="input-responsive"
                onChange={(e) => setPasswordValue(e.target.value)}
              />
            </>
          )}
          {inputPassword && (
            <>
              <Input
                name="password_check"
                type="password"
                placeholder="Повторите пароль"
                className="input-responsive"
                onChange={(e) => setPasswordValueCheck(e.target.value)}
              />
              {password.length >= 4 && passwordCheck.length >= 1 && !passwordsMatch && (
                <p className="text-center text-sm text-red-500">Пароли не совпадают</p>
              )}
              {password.length < 4 && (
                <div className="text-center text-sm text-gray-500">
                  Пароль должен содержать минимум 4 символа
                </div>
              )}
            </>
          )}
          {isLogin && (
            <Input
              name="passw"
              type="password"
              placeholder="Введите пароль"
              className="input-responsive mt-6"
              onChange={(e) => setPasswordValue(e.target.value)}
            />
          )}
        </CardContent>
        <CardFooter className="flex flex-col px-0 py-0">
          <Button
            variant="default"
            className="button-responsive mb-4"
            type="submit"
            disabled={
              (inputCode && code.length < 4) ||
              (!inputCode && !inputPassword && phone.length < 10) ||
              (inputPassword && (!passwordsMatch || password.length < 4)) ||
              (isLogin && password.length < 1)
            }
          >
            {isLogin ? "Войти" : "Продолжить"}
          </Button>
          {isLogin && (
            <Typography
              variant="muted"
              className="mb-4 block rounded-lg border bg-primary/10 p-2 text-center"
            >
              Если вы в первый раз заходите в личный кабинет, установите пароль
            </Typography>
          )}
          {isLogin ? (
            <div className="text-center text-sm text-gray-500">
              <NavLink to={REGISTRATION_ROUTE} className="auth-link">
                Установить новый пароль
              </NavLink>
            </div>
          ) : (
            <div className="text-center text-sm text-gray-500">
              <NavLink to={LOGIN_ROUTE} onClick={loginToggle} className="auth-link">
                Вернуться на страницу входа
              </NavLink>
            </div>
          )}
        </CardFooter>
      </form>
    </Card>
  );
};

export default AuthForm;
